"use client";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@scott/ui/utils/cn";
import type { BrandConfig } from "@ui-d2c/types";
import { cva, type VariantProps } from "class-variance-authority";

const logoVariants = cva("", {
  variants: {
    variant: {
      default: "h-auto w-40 lg:w-36 xl:w-40",
      medium: "h-auto w-28",
      small: "h-auto w-20",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface LogoProps extends VariantProps<typeof logoVariants> {
  brand: BrandConfig;
  url?: string;
  asChild?: boolean;
  mainLogoUrl?: string;
  sideLogoUrl?: string;
  isSide?: boolean;
  /** Image loading hint for the rendered <img> element. */
  loading?: "lazy" | "eager";
}

const Logo = ({
  brand,
  mainLogoUrl,
  sideLogoUrl,
  variant,
  url,
  isSide = false,
  asChild = false,
  loading,
}: LogoProps) => {
  const Comp = asChild ? Slot : "div";

  const mainLogoUrlDefault = `/assets/${brand.value}-logo/mainnav-logo.svg`;
  const sideLogoUrlDefault = `/assets/${brand.value}-logo/sidenav-logo.svg`;

  return (
    <a href={url}>
      <Comp className={cn(logoVariants({ variant }))}>
        {isSide ? (
          <img
            alt="logo"
            loading={loading ?? "lazy"}
            src={sideLogoUrl ?? sideLogoUrlDefault}
          />
        ) : (
          <img
            alt="logo"
            loading={loading ?? "eager"}
            src={mainLogoUrl ?? mainLogoUrlDefault}
          />
        )}
      </Comp>
    </a>
  );
};

export { Logo, logoVariants };
